import type { HTMLAttributes, ReactNode } from 'react';
import styles from '../styles.module.css';
import toolbarStyles from './ManagementFilterBar.module.css';

type ManagementFilterBarProps = {
  label: string;
  filters: ReactNode;
  actions: ReactNode;
  fieldsetAttributes?: Omit<
    HTMLAttributes<HTMLFieldSetElement>,
    'aria-label' | 'className'
  > & { [key: `data-${string}`]: string | undefined };
};

export function ManagementFilterBar({
  label,
  filters,
  actions,
  fieldsetAttributes,
}: ManagementFilterBarProps) {
  return (
    <fieldset
      {...fieldsetAttributes}
      className={`${styles.filterBar} ${toolbarStyles.container}`}
      aria-label={label}
    >
      <div className={toolbarStyles.filterFields}>{filters}</div>
      <div className={toolbarStyles.filterActions}>{actions}</div>
    </fieldset>
  );
}
